import { render } from "./CatalogoView.vue?vue&type=template&id=5bdc042f&ts=true"
import script from "./CatalogoView.vue?vue&type=script&lang=ts"
export * from "./CatalogoView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__